/**
 * RAG (Asistente normativo) service
 */

import { apiClient } from '../utils/api';
import type { ApiResponse } from '../../../shared/src/types';

export interface AskQuestionData {
  question: string;
  installation_id?: string;
  installation_type?: string;
  checklist_item_id?: string;
  context?: string;
}

export interface Citation {
  itc_reference?: string;
  section?: string;
  page?: number;
  chunk_id: string;
  relevance_score: number;
}

export interface AskResponse {
  answer: string;
  citations: Citation[];
  has_sufficient_support: boolean;
  recommended_evidence?: string[];
  practical_implication?: string;
}

export async function askQuestion(data: AskQuestionData): Promise<AskResponse> {
  const response = await apiClient.post<ApiResponse<AskResponse>>('/ask', data);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error asking question');
  }

  if (!response.data.data) {
    throw new Error('Invalid response from server');
  }

  return response.data.data;
}
